import { render, staticRenderFns } from "./im-scroll.vue?vue&type=template&id=fa79d1b4&scoped=true&"
import script from "./im-scroll.vue?vue&type=script&lang=js&"
export * from "./im-scroll.vue?vue&type=script&lang=js&"
import style0 from "./im-scroll.vue?vue&type=style&index=0&id=fa79d1b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa79d1b4",
  null
  
)

export default component.exports